<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-2">
                                <h4 class="card-title">All EID PT Rounds</h4>
                            </div>
                            <div class="col-md-10 text-right">
                                <b-button variant="success">
                                    <i class="ri-file-excel-2-line align-middle mr-2"></i> Export
                                </b-button>
                            </div>
                            <b-modal
                                    id="modal-delete"
                                    centered
                                    title="Confirm Delete"
                                    title-class="font-18"
                                    ref="my-modal"
                                    hide-footer

                            >
                                <center>  <span  >Are you sure you want to Delete?</span></center>
                                <div class="text-center">
                                    <button
                                            class="btn btn-danger w-md waves-effect waves-light mt-4"
                                            @click="hideModal"
                                    >No</button>
                                    <button
                                            class="btn btn-primary w-md waves-effect waves-light mt-4 mx-3"
                                            type="submit"
                                            @click="del(selectedID),hideModal()"
                                    >Yes</button>
                                </div>

                            </b-modal>

                        </div>

                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                    :items="vlData"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"

                                    @filtered="onFiltered"
                            >
                                <template v-slot:cell(actions)="{item}">
                                    <b-button class="actionBut" v-b-tooltip.hover  title="View Details"  variant="info" @click="view(item)">
                                        <i class="ri-eye-fill align-middle "></i>
                                    </b-button>
                                    <b-button class="actionBut" v-b-tooltip.hover title="Edit" variant="success" @click="edit(item)" >
                                        <i class="ri-edit-fill align-middle "></i>
                                    </b-button>
                                    <b-button class="actionBut" v-b-tooltip.hover  v-b-modal.modal-delete @click="choosenID(item)"  title="Delete" variant="danger">
                                        <i class="ri-delete-bin-2-fill align-middle "></i>
                                    </b-button>
                                </template>
                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="lodader__content" v-if="loader">
            <b-spinner style="width: 3rem; height: 3rem" class="loader" variant="success" label="Spinning"></b-spinner>
        </div>
    </Layout>

</template>

<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";

    import { tableData } from "./dataPT";
    import {axios_delete, axios_get} from "../../../helpers/helper";

    /**
     * Advanced table component
     */
    export default {
        page: {
            title: "View Sites",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: { Layout, PageHeader },
        data() {
            return {

                tableData: tableData,
                vlData:[],
                loader: false,
                user:null,
                selectedID:null,
                title: "View EID PT",
                items: [
                    {
                        text: "EID PT Rounds",
                        href: "/"
                    },
                    {
                        text: "View EID PT Rounds",
                        active: true
                    }
                ],
                totalRows: 1,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                sortBy: "age",
                sortDesc: false,
                fields: [
                    { key: "reference", sortable: true },
                    { key: "pt_session", sortable: true },
                    { key: "month", sortable: true },
                    { key: "year", sortable: true },
                    { key: "state", sortable: true },
                    { key: "actions", sortable: true },



                ],



            };
        },
        computed: {
            /**
             * Total no. of records
             */
            rows() {
                return this.tableData.length;
            }
        },
        mounted() {
            this.user=JSON.parse(localStorage.getItem('user'))
            this.totalRows = this.items.length;
            axios_get("/pt_rounds",{},(d)=>{
                    console.log(d)
                    //this.countryData=d;
                    this.vlData=d.filter(e=>{return e.pt_type=='EID' && e.country_id == this.user.country_id})
                    //this.vlData=this.vlData.filter(e=>{return e.pt_type=='EID'})
                    console.log(this.vlData)
                },(e)=>{
                    console.log("error",e);
                },()=>{
                    console.log("finishing");
                }
            );
        },
        methods: {
            // editItem(item) { console.log(item); },
            /**
             * Search the table data with search input
             */
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
            hideModal() {
                this.$refs['my-modal'].hide()
            },
            view(e){
                console.log(e)
                window.location.href = "/pt-round/"+e.id
            },

            edit(e){
                console.log(e)
                window.location.href = "/pt-round/edit/"+e.id
            },
            choosenID(e){
                console.log(e)
                this.selectedID=e
                console.log(this.selectedID)
                return this.selectedID

            },
            del(e){
                this.loader = true
                const  index = this.vlData.indexOf(e)
                console.log(e)
                this.pt_id=e.id
                // console.log(this.site_id)
                axios_delete("/pt_rounds/"+this.pt_id,{
                    },
                    (d)=>{
                        console.log(d)
                        this.vlData.splice(index,1)
                        window.makeToast('Success','PT Round Deleted Successfully','success')
                    },(e)=>{
                        console.log("error",e);
                    },()=>{
                        console.log("finishing");
                        this.loader = false
                    }
                );
            },

        }
    };
</script>

<style scoped>
    .actionBut{
        margin-left: 15px;

    }

</style>
